export interface ICommand { }

export class SendEmailCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.Emails.Commands.SendEmailCommandV1, TCh.Domain.RankHR'

	Subject: string
	MessageHtml: string
	RecipientsIds: any
	IncludeSurveyLink: boolean
	IncludeReportLink: boolean

	constructor (subject: string, messageHtml: string, recipientsIds: any, includeSurveyLink: boolean, includeReportLink: boolean)
	{
		this.Subject = subject
		this.MessageHtml = messageHtml
		this.RecipientsIds = recipientsIds
		this.IncludeSurveyLink = includeSurveyLink
		this.IncludeReportLink = includeReportLink
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.Emails.Commands.SendEmailCommandV1, TCh.Domain.RankHR'
	}

}

